import CrudFormLayout from "../../../Layout/CrudFormLayout";
import AboutUsForm from "./AboutUsForm";

const AboutUsFormContainer = ({ apiHandler, editData }) => {
  const initialValue = {
    title: editData?.title || "",
    side_img: editData?.side_img || "",
    middle_img: editData?.bottom_img || "",
    circle_img: editData?.circle_img || "",
    img1: editData?.img1 || "",
    img2: editData?.img2 || "",
    button_title: editData?.button_title || "",
    description: editData?.description || "",
    experience: editData?.experience || "",
    box1Title: editData?.box1Title || "",
    box1Description: editData?.box1Description || "",
    box2Title: editData?.box2Title || "",
    box2Description: editData?.box2Description || "",
    status: editData ? editData?.status : 1,
  };

  const formHandler = async (formData) => {
    if (apiHandler) {
      return apiHandler(formData);
    }
    return null;
  };
  return (
    <CrudFormLayout
      initialValues={initialValue}
      apiHandler={formHandler}
      buttonCenter
    >
      <AboutUsForm />
    </CrudFormLayout>
  );
};

export default AboutUsFormContainer;
